import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { CustomerOrdersWorkspaceLayout } from "@/screens/CustomerOrders/components/CustomerOrdersWorkspace/CustomerOrdersWorkspaceLayout"
import { CUSTOMER_ORDER_ACCESS_PERMISSIONS } from "@/screens/CustomerOrders/constants"

export const Route = createFileRoute("/app/orders/$companyId/$shipToLocationId/_layout")({
  component: () => (
    <PermissionContentWrapper permissions={CUSTOMER_ORDER_ACCESS_PERMISSIONS}>
      <CustomerOrdersWorkspaceLayout />
    </PermissionContentWrapper>
  ),
})
